import {
  isOrganizationBluepoint,
  isOrganizationBx,
  isOrganizationLevel,
} from "../../../../../utils/helper/specialized";

export const getOrganizationForCalcs = organization => {
  if (isOrganizationLevel(organization)) return "level2";
  else if (isOrganizationBluepoint(organization)) return "goals";
  else if (organization) return organization;
  else return "level2";
};

export const getProposalAum = productMap =>
  productMap
    ? Object.keys(productMap)
        .map(key => productMap[key].at(-1).investmentAmount)
        .reduce((acc, value) => acc + value, 0)
    : 0;

export const getValidProductId = ({
  organization,
  productsList,
  proposalProductId,
  proposalRiskTolerance,
}) => {
  if (isOrganizationBx(organization)) {
    if (
      !proposalProductId ||
      !productsList.find(it => it._id === proposalProductId)
    ) {
      return productsList.find(it => it.Name === "BX US Equity Growth Model")
        ?._id;
    }

    return proposalProductId;
  }

  const legacyLevelProductsList = [71, 72, 73, 74, 75];
  const isLegacyProductSelected =
    !proposalProductId || legacyLevelProductsList.includes(proposalProductId);

  const recommendedModelId = productsList
    ?.filter(it => it.isTemplate)
    ?.find(it => it.RiskType?.toLowerCase() === proposalRiskTolerance)?._id;

  const getRecommendedEtfTicker = () => {
    if (proposalRiskTolerance === "aggressive") return "XITK";
    if (proposalRiskTolerance === "growth") return "SPY";
    if (proposalRiskTolerance === "moderate") return "XTN";
    if (proposalRiskTolerance === "conservative") return "XBI";
    if (proposalRiskTolerance === "preservation") return "BNDX";
  };

  const recommendedEtfId = productsList.find(
    it => it.Code === getRecommendedEtfTicker()
  )?._id;

  if (isLegacyProductSelected || !proposalProductId) {
    return recommendedModelId || recommendedEtfId;
  }

  return proposalProductId;
};
